import { useEffect, useState } from "react";
import { Link } from "react-router";
import { useI18n } from "../../i18n/I18nProvider";
import { api, imageUrl, type Watch } from "../../lib/api";
import { useMoney } from "../../lib/CurrencyProvider";

/** Mi cuenta › Mis avisos (#avisos): pending back-in-stock and price-drop alerts. */
export function WatchesList() {
  const { t, locale } = useI18n();
  const { format } = useMoney();
  const [watches, setWatches] = useState<Watch[] | null>(null);

  useEffect(() => {
    const ctrl = new AbortController();
    api.watches(ctrl.signal).then(setWatches).catch(() => setWatches([]));
    return () => ctrl.abort();
  }, []);

  if (!watches) return null;
  const remove = async (id: number) => {
    await api.deleteWatch(id).catch(() => {});
    setWatches(watches.filter((w) => w.id !== id));
  };

  return (
    <section id="avisos" className="watches" aria-labelledby="watches-title">
      <h2 id="watches-title" className="section-title">
        {t("watch.title")}
      </h2>
      {watches.length === 0 ? (
        <p className="muted">{t("watch.empty")}</p>
      ) : (
        <ul className="watch-list">
          {watches.map((w) => (
            <li key={w.id}>
              <img src={imageUrl(w.image_key)} alt="" width={48} height={48} loading="lazy" />
              <div>
                <Link to={`/producto/${w.slug}`}>{locale === "en" ? w.name_en : w.name_es}</Link>
                <span className="muted small">
                  {w.kind === "stock" ? t("watch.kindStock") : w.target_price ? t("watch.kindPriceTarget", { price: format(w.target_price) }) : t("watch.kindPrice")}
                  {w.kind === "price" && ` · ${format(w.price)}`}
                </span>
              </div>
              <button type="button" className="btn btn-link btn-sm" onClick={() => remove(w.id)}>
                {t("watch.cancel")}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
